import {
	ADD_DB_SUCCESS,
	ADD_DB_FAIL,
	GET_DB_SUCCESS,
	GET_DB_FAIL,
	GET_DBS_SUCCESS,
	GET_DBS_FAIL,
	UPDATE_DB_SUCCESS,
	UPDATE_DB_FAIL,
	DELETE_DB_SUCCESS,
	DELETE_DB_FAIL,
	SET_DB_LOADING,
	CLEAR_DB_ERROR,
} from './types';

const initialState = {
	loading: false,
	database: null,
	databases: [],
};

const databaseReducer = function (state = initialState, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_DB_LOADING:
			return {
				...state,
				loading: true,
			};

		case CLEAR_DB_ERROR:
			return {
				...state,
				error: null,
				updated: false,
				database: null,
			};

		case ADD_DB_SUCCESS:
			return {
				...state,
				database: action.payload,
				loading: false,
			};

		case GET_DBS_SUCCESS:
			return {
				...state,
				databases: action.payload,
				loading: false,
			};

		case GET_DB_SUCCESS:
			return {
				...state,
				database: action.payload,
				loading: false,
			};

		case UPDATE_DB_SUCCESS:
			return {
				...state,
				database: action.payload,
				loading: false,
				updated: true,
				databases: state.databases.map((database) => {
					if (database._id === action.payload._id) {
						return action.payload;
					} else {
						return database;
					}
				}),
			};

		case DELETE_DB_SUCCESS:
			return {
				...state,
				databases: state.databases.filter(
					(database) => database._id !== action.payload
				),
				loading: false,
			};

		case GET_DBS_FAIL:
		case GET_DB_FAIL:
		case UPDATE_DB_FAIL:
		case ADD_DB_FAIL:
		case DELETE_DB_FAIL:
			return {
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};

export default databaseReducer;
